import { Injectable, inject } from '@angular/core';

import { UrlConstants } from '../config/urlConstants';
import { BehaviorDataService } from './behaviorData.service';
import { BetslipQdApiService } from './betslipqd-api.service';
import { DataService } from './data.service';
import { OptionListService } from './optionList.service';
import { StoreService } from './store.service';

@Injectable({
    providedIn: 'root',
})
export class StakeAmountService {
    private store = inject(StoreService);
    data: any = {};
    isPriceChanged: boolean;

    constructor(
        private dataService: DataService,
        private optionListService: OptionListService,
        private behaviorData: BehaviorDataService,
        private apiService: BetslipQdApiService,
    ) {}

    intialize() {
        this.data = {
            ...this.dataService.sessionInfo,
            estimatedReturn: 0.0,
            currency: '',
            initialized: false,
            priceChanged: false,
            betSuspended: false,
        };
    }

    isStakeAmountServiceInitialized() {
        return this.data.initialized;
    }

    set currency(currency) {
        this.data.currency = currency;
    }

    get currency() {
        return this.data.currency;
    }
    set stake(stake: any) {
        this.data.stake = stake;
    }

    retrieveAmountRequiredToMeetStake(callback: any) {
        if (this.data?.stake === 0) {
            if (typeof callback === 'function') {
                callback();
            }
            return;
        }

        const estimatedReturn = this.dataService.sessionInfo?.estimatedReturn || '0';
        if (estimatedReturn) {
            this.data.estimatedReturn = parseFloat(estimatedReturn).toFixed(2);
            this.behaviorData.estimatedReturn.next(this.data.estimatedReturn);
        }

        let queryString = `?stake=${this.data?.stake}`;
        if (this.dataService.sessionInfo?.version === 'v2') {
            queryString += `&walletBucketType=${this.dataService.sessionInfo?.walletBucketType}`;
        }
        this.getStakeAmount(queryString, callback);
    }

    getCurrency() {
        return this.data.currency;
    }

    addEventListener(event: any) {
        if (typeof event?.data === 'string' && event.data.includes('eventName')) {
            const messageData = JSON.parse(event?.data);
            if (['StakeChange', 'PriceChange'].includes(messageData?.eventName)) {
                if (messageData.eventName == 'PriceChange') {
                    this.isPriceChanged = true;
                    this.behaviorData.isPriceChanged.next(true);
                }

                this.data.stake = messageData.eventData?.stake / 100;
                if (!isNaN(messageData?.eventData?.estimatedReturn) && messageData?.eventData?.estimatedReturn != 0) {
                    this.data.estimatedReturn = parseFloat((messageData.eventData.estimatedReturn / 100).toString()).toFixed(2);
                    this.behaviorData.estimatedReturn.next(this.data.estimatedReturn);
                }
                const queryString = `?stake=${this.data?.stake}`;
                this.getStakeAmount(queryString);
            } else if (messageData.eventName == 'EventSuspended') {
                this.data.betSuspended = true;
                this.behaviorData.isBetSuspended.next(true);
            } else if (messageData.eventName == 'EventUnSuspended') {
                this.data.betSuspended = false;
                this.behaviorData.isBetSuspended.next(false);
            }
        }
    }

    getStakeAmount(queryString: string, callback: any = null) {
        this.behaviorData.changeStakeAmount(this.data?.stake);
        this.apiService.get(UrlConstants.STAKE_AMOUNT_URI + queryString).subscribe((response) => {
            if (response) {
                this.data.currency = response.currencyCode;
                this.data.amountRequiredToMeetStake = parseFloat(response.value).toFixed(2);
                this.data.initialized = true;
                this.behaviorData.changeStakeCurrency(this.data?.currency);
                this.store.setRequiredAmount(this.data.amountRequiredToMeetStake);
                this.behaviorData.changeAmountRequiredToMeetStake.next(this.data.amountRequiredToMeetStake);
            }
            if (typeof callback === 'function') {
                callback(this.data.amountRequiredToMeetStake);
            }
        });
    }

    getAmountToBePopulated(txnCurrency: any = null, conversionRates: any) {
        let returnAmount: any;
        if (this.data?.amountRequiredToMeetStake === 0 || !conversionRates) {
            returnAmount = '';
        }

        if (txnCurrency) {
            const accountCurrency = this.optionListService?.selectedOption?.paymentMethodInfo?.minDepositLimit?.currencyCode;
            const key = `${txnCurrency.toUpperCase()}_TO_${accountCurrency.toUpperCase()}`;
            let exchangeRate = 1.0;
            exchangeRate = conversionRates[key];
            returnAmount = parseFloat((this.data?.amountRequiredToMeetStake / exchangeRate).toString()).toFixed(2);
        } else {
            returnAmount = parseFloat(this.data?.amountRequiredToMeetStake).toFixed(2);
        }
        this.store.setRequiredAmount(returnAmount);
        this.behaviorData.changeAmountRequiredToMeetStake.next(returnAmount);
        return returnAmount;
    }
}
